import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Alert } from '@mui/material';

// Import the real Stripe components
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key from environment variables
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripePublishableKey) {
  console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY environment variable is not set. Stripe will not work correctly.');
}
const stripePromise = loadStripe(stripePublishableKey || '');
const isTestMode = stripePublishableKey?.startsWith('pk_test_');

const StripeProvider = ({ children }) => {
  return (
    <Box>
      {isTestMode && (
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom>
            Stripe Test Mode
          </Typography>
          <Typography variant="body2">
            You are currently using Stripe in test mode. Payments will not charge real money.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Test card numbers:
          </Typography>
          <ul>
            <li>Success: 4242 4242 4242 4242</li>
            <li>Requires authentication: 4000 0025 0000 3155</li>
            <li>Declined: 4000 0000 0000 0002</li>
          </ul>
        </Alert>
      )}

      <Elements stripe={stripePromise}>
        {children}
      </Elements>
    </Box>
  );
};

StripeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default StripeProvider;
